/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable consistent-return */
import React, { FunctionComponent, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import {
  selectInterventionsChecklistValue,
  calculatorActions,
  selectInterventionsValue,
  selectServiceDataForm,
  selectReportName,
  selectState,
  selectTouched
} from '../../../../redux/calculatorSlice';
import {
  InterventionsChecklistForm,
  PostpartumMaternalDepressionForm,
  IPostpartumMaternalDepression,
  InterventionsCommonForm
} from '../../../../interfaces/interventions.interface';
import { CalculatorEnum } from '../../../../interfaces/calculator.interface';
import {
  InterventionHeader,
  InterventionBody,
  InterventionFooter,
  InterventionContainer,
  InterventionFieldNoteDialog
} from '../Intervention';
import { FormValidations, StringFormatter, Constants } from '../../../../utils';
import useDebounceEffect from '../../../../hooks/useDebounceEffect';
import { PostpartumMaternalDepression as PostpartumMaternalDepressionClass } from '../../../../calculations';
import { paths } from '../../..';
import { useLocation } from 'react-router';
import { Tooltip } from '../../../../components';
import { Box, Link, Typography } from '@mui/material';

const { DIALOG_MODES } = Constants,

  PostpartumMaternalDepression: FunctionComponent = () => {

    const dispatch = useDispatch(),
      navigate = useNavigate(),

      location = useLocation(),
      switchValue = useSelector(
        selectInterventionsChecklistValue(
          InterventionsChecklistForm.PostpartumMaternalDepression
        )
      ),
      postpartumData = useSelector(
        selectInterventionsValue(CalculatorEnum.PostpartumMaternalDepression)
      ),

      serviceData = useSelector(selectServiceDataForm),
      selectedState = useSelector(selectState),

      reportName = useSelector(selectReportName),

      [reinitialize, setReinitialize] = useState(true),
      touched = useSelector(selectTouched),
      [noteName, setNoteName] = useState<string>(''),
      [noteAction, setNoteAction] = useState<'add' | 'edit' | 'delete'>(DIALOG_MODES.ADD),
      [isNoteDialogOpen, setIsNoteDialogOpen] = useState(false),

      fields = [
        {
          text: `Number of Medicaid-enrolled mothers who discussed postpartum maternal discussed postpartum maternal depression with a HS Specialist within 12 months of delivery (either in-person or telephonically)
      `,
          id: PostpartumMaternalDepressionForm.DiscussedProblem,
          showError: true,
        },
        {
          text: `Number of Medicaid-enrolled mothers who received counseling or related services from a HS Specialist directly and/or were referred for additional services for postpartum maternal depression
      `,
          id: PostpartumMaternalDepressionForm.ReceivedCounseling,
          showError: true,
        },
        // {
        //   text: `Number of mothers that the HS Specialist(s) referred for counseling or other services for postpartum maternal depression
        //   `,
        //   id: PostpartumMaternalDepressionForm.ReferredForServices,
        //   showError: true,
        // },
      ],

      onSubmit = (values: IPostpartumMaternalDepression) => {

        if (touched) {

          dispatch(
            calculatorActions.saveReport({
              reportName,
              update: true,
              navigate: navigate,
              pathname: location.pathname
            }));

        }
        navigate(
          StringFormatter.replaceWithReportName(
            reportName,
            paths.interventionsHealthyBirthSpacing
          )
        );

      };

    useEffect(() => {

      if (switchValue) {

        const timeout = setTimeout(() => {

          setReinitialize(false);

        }, 250);

        return () => {

          clearTimeout(timeout);

        };

      }

    }, [switchValue]);

    const form = useFormik({
      initialValues: {
        ...postpartumData,
        [InterventionsCommonForm.LongTermSavingsLow]:
          postpartumData[InterventionsCommonForm.LongTermSavingsLow] || '0',
        [InterventionsCommonForm.LongTermSavingsHigh]:
          postpartumData[InterventionsCommonForm.LongTermSavingsHigh] || '0'
      },
      onSubmit,
      validationSchema: switchValue && FormValidations.intervention({
        [PostpartumMaternalDepressionForm.DiscussedProblem]:
          FormValidations.interventionNumberOfChilds(PostpartumMaternalDepressionForm.DiscussedProblem, serviceData.csInput3),
        [PostpartumMaternalDepressionForm.ReceivedCounseling]:
          FormValidations.interventionNumberOfChilds(PostpartumMaternalDepressionForm.ReceivedCounseling, serviceData.csInput3),
        // [PostpartumMaternalDepressionForm.ReferredForServices]:
        //   FormValidations.interventionNumberOfChilds(PostpartumMaternalDepressionForm.ReferredForServices, serviceData.csInput3),
      }),
      validateOnBlur: false,
      validateOnChange: false,
      enableReinitialize: reinitialize || !switchValue,
    });

    useEffect(() => {

      if (!switchValue) {

        form.resetForm();
        dispatch(
          calculatorActions.clearInterventionData(
            CalculatorEnum.PostpartumMaternalDepression
          )
        );

      }

    }, [switchValue]);

    useDebounceEffect(() => {

      const hasBeenEdited = Object.keys(form.values).some(
        (key) => !!form.values[key]
      );
      if (!form.dirty && !hasBeenEdited) return;
      /** Calculations happen */
      const maternalDepression = new PostpartumMaternalDepressionClass({
        state: selectedState,
        serviceData,
        lowEstimatedSlider: +form.values[InterventionsCommonForm.LowEstimate],
        highEstimatedSlider: +form.values[InterventionsCommonForm.HighEstimate],
        maternalDepressionReceivedCounseling: +form.values[PostpartumMaternalDepressionForm.ReceivedCounseling],
      }),

        // Short Term Savings Calculations
        savingsLow = maternalDepression.maternalDepressionEstimatedSavingsLow(),
        savingsHigh = maternalDepression.maternalDepressionEstimatedSavingsHigh(),

        // Long Term Savings Calculations
        longTermSavingsLow = maternalDepression.maternalDepressionEstimatedLongTermSavingsLow(),
        longTermSavingsHigh = maternalDepression.maternalDepressionEstimatedLongTermSavingsHigh();

      if (
        +form.values[InterventionsCommonForm.SavingsLow] !== savingsLow ||
        +form.values[InterventionsCommonForm.SavingsHigh] !== savingsHigh ||
        +form.values[InterventionsCommonForm.LongTermSavingsLow] !== longTermSavingsLow ||
        +form.values[InterventionsCommonForm.LongTermSavingsHigh] !== longTermSavingsHigh
      ) {

        form.setValues({
          ...form.values,
          [InterventionsCommonForm.SavingsLow]: savingsLow.toString(),
          [InterventionsCommonForm.SavingsHigh]: savingsHigh.toString(),
          [InterventionsCommonForm.LongTermSavingsLow]: longTermSavingsLow.toString(),
          [InterventionsCommonForm.LongTermSavingsHigh]: longTermSavingsHigh.toString(),
        });

      }

      form.validateForm().then((errors) => {

        const isValid = !Object.keys(errors).length;

        if (form.dirty) {

          dispatch(
            calculatorActions.setInterventionData({
              intervention: CalculatorEnum.PostpartumMaternalDepression,
              value: { ...form.values, isValid: !!isValid },
            })
          );
          dispatch(calculatorActions.setSummaryData());

        }

      });

    }, [form.values]);

    const onSwitchChange = (e: React.ChangeEvent<HTMLInputElement>) => {

      dispatch(
        calculatorActions.toggleInterventionsChecklistValue({
          key: InterventionsChecklistForm.PostpartumMaternalDepression,
          value: e.target.checked,
        })
      );

    },

      onNote = (noteName: string, noteAction: 'add' | 'edit' | 'delete') => {

        setNoteName(noteName);
        setNoteAction(noteAction);
        setIsNoteDialogOpen(true);

      },

      onDialogNoteClose = () => {

        setIsNoteDialogOpen(false);

      };

    return (
      <>
        <InterventionContainer
          disabled={!switchValue}
          onSubmit={form.handleSubmit}
          header={
            <InterventionHeader
              title="Postpartum Maternal Depression"
              checked={switchValue}
              onChange={onSwitchChange}
            />
          }
          body={
            <InterventionBody
              description={
                <>
                  Some HS Specialists talk with caregivers about postpartum maternal depression. The following questions ask about the actions taken by mothers in these situations during the 12-month date range.
                  <Tooltip
                    id="postpartum_maternal_depression_section"
                    placement="right"
                    title={
                      <Box>
                          Postpartum depression is different from the “baby blues”, which typically last for a few days to two weeks immediately following childbirth and are characterized by exhaustion and overwhelm.
                          Symptoms of postpartum depression are more severe and last longer, including up to a year following childbirth.
                          These symptoms will generally not resolve without formal treatment.
                          (Sources: <Link href="https://www.mayoclinic.org/diseases-conditions/postpartum-depression/symptoms-causes/syc-20376617" target="_blank" rel="noopener"> Postpartum depression - Symptoms and causes - Mayo Clinic</Link>; 
                          <Link href="https://www.ncbi.nlm.nih.gov/books/NBK519070/" target="_blank" rel="noopener">Perinatal Depression - StatPearls - NCBI Bookshelf;</Link> 
                          <Link href="https://www.nimh.nih.gov/health/publications/perinatal-depression" target="_blank" rel="noopener"> Perinatal Depression - National Institute of Mental Health (NIMH);</Link>
                         )
                      </Box>
                    }
                  >
                    { }
                  </Tooltip>

                </>
              }
              form={form}
              fields={fields}
              onNote={onNote}
            />
          }
          footer={
            <InterventionFooter
              form={form}
              savingsText="Postpartum maternal depression"
              description="Percent reduction in number of mothers with persistent depression due to HealthySteps"
              onNote={onNote}
            />
          }
        />
        <InterventionFieldNoteDialog
          id={`${noteName}__${noteAction}-dialog`}
          name={noteName}
          value={form.values[noteName]}
          mode={noteAction}
          open={isNoteDialogOpen}
          onClose={onDialogNoteClose}
          form={form}
        />
      </>
    );

  };

export default PostpartumMaternalDepression;
